import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

/**
 * Chrome for AnchorPopup: optional close button, HTML body, optional spinner,
 * secondary Cancel button (left), optional Submit button (right).
 *
 * View-model observables are set by the owning AnchorPopup instance via its
 * setLoading(), setSubmitVisible(), and constructor options (showClose, showSubmit, cancelButtonText, submitButtonText, onSubmit).
 */
export class anchorPopup_template extends vnTemplate {

    protected buildViewModel(): any {
        const self = this;
        return {
            bodyHtml:              ko.observable(""),
            loading:               ko.observable(false),
            submitButtonVisible:   ko.observable(true),
            cancelButtonVisible:   ko.observable(true),
            cancelButtonText:      ko.observable("Cancel"),
            submitButtonText:      ko.observable("Submit"),
            showClose:             ko.observable(true),
            onClickClose: function () {
                self.caller.anchorPopupSubmitClose();
            },
            onClickCancel: function () {
                self.caller.anchorPopupSubmitCancel();
            },
            onClickSubmit: function () {
                self.caller.anchorPopupSubmitSubmit();
            }
        };
    }

    protected getTemplateName(): string {
        return "anchorPopup_template";
    }

    protected getTemplateHtml(): string {
        return /* html */`
            <div class="anchor-popup__shell">
                <button type="button" class="anchor-popup__close icon i-close" data-bind="visible: showClose, click: onClickClose" aria-label="Close"></button>
                <span class="anchor-popup__nub" aria-hidden="true"></span>
                <div class="anchor-popup__body" data-bind="html: bodyHtml"></div>

                <div class="anchor-popup__footer">
                    <button type="button" class="btn light" style="box-shadow: none;" data-bind="text: cancelButtonText, click: onClickCancel, visible: cancelButtonVisible"></button>
                    <div class="anchor-popup__footer-submit">
                        <span class="anchor-popup__spinner" aria-hidden="true" data-bind="visible: loading"></span>
                        <button type="button" class="btn highlight" data-bind="text: submitButtonText, click: onClickSubmit, visible: submitButtonVisible, disabled: loading"></button>
                    </div>
                </div>
            </div>
        `;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/anchorPopup_template.ts